package dev.lingvo.site

import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import dev.lingvo.site.components.studio.preview.DesignLooks
import androidx.compose.runtime.LaunchedEffect
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.minHeight
import com.varabyte.kobweb.core.App
import com.varabyte.kobweb.silk.SilkApp
import com.varabyte.kobweb.silk.components.layout.Surface
import com.varabyte.kobweb.silk.style.common.SmoothColorStyle
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import com.varabyte.kobweb.silk.theme.colors.saveToLocalStorage
import dev.lingvo.site.api.AuthProviders
import dev.lingvo.site.ds.COLOR_MODE_KEY
import org.jetbrains.compose.web.css.vh

@App
@Composable
fun AppEntry(content: @Composable () -> Unit) {
    remember { DesignLooks.installProduction() }
    SilkApp {
        // Persist the visitor's choice so the toggle survives a reload and every navigation.
        val colorMode = ColorMode.current
        LaunchedEffect(colorMode) {
            colorMode.saveToLocalStorage(COLOR_MODE_KEY)
        }
        // Asked once, here, rather than by each sign-in page when it happens to render. See
        // AuthProviders for why.
        LaunchedEffect(Unit) { AuthProviders.load() }
        Surface(SmoothColorStyle.toModifier().minHeight(100.vh)) {
            content()
        }
    }
}
